export const imports = {
  'docs/changelog.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "docs-changelog" */ 'docs/changelog.mdx'
    ),
  'docs/home.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "docs-home" */ 'docs/home.mdx'
    ),
  'docs/quick-start.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "docs-quick-start" */ 'docs/quick-start.mdx'
    ),
  'docs/introduction.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "docs-introduction" */ 'docs/introduction.mdx'
    ),
  'docs/components/alert.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "docs-components-alert" */ 'docs/components/alert.mdx'
    ),
  'docs/components/flex.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "docs-components-flex" */ 'docs/components/flex.mdx'
    ),
  'docs/components/icon.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "docs-components-icon" */ 'docs/components/icon.mdx'
    ),
  'docs/components/white-space.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "docs-components-white-space" */ 'docs/components/white-space.mdx'
    ),
  'docs/components/wing-blank.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "docs-components-wing-blank" */ 'docs/components/wing-blank.mdx'
    ),
}
